import { CircleSlash } from 'lucide-react';
import type { ReactNode } from 'react';

/** Studio-style empty state: a quiet icon, a title and one line of direction, centred on the page. */
export function EmptyState({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-20 text-center">
      <CircleSlash className="text-muted-foreground mb-3 size-5" aria-hidden />
      <h2 className="text-sm font-medium">{title}</h2>
      {children && <div className="text-muted-foreground mt-1 max-w-md text-xs">{children}</div>}
    </div>
  );
}
